import { render, staticRenderFns } from "./resumen_pendientes.vue?vue&type=template&id=dae19704&scoped=true"
import script from "./resumen_pendientes.vue?vue&type=script&lang=js"
export * from "./resumen_pendientes.vue?vue&type=script&lang=js"
import style0 from "./resumen_pendientes.vue?vue&type=style&index=0&id=dae19704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae19704",
  null
  
)

export default component.exports